import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

import StoriesAboutUsRoute from './AboutUs';
import StoriesGiantBikeSchoolRoute from './GiantBikeSchool';
import StoriesGiantAdventureRoute from './GiantAdventure';

const routes: CustomRoute = {
	path: appPath.stories,
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'Stories' */ './component')],
			render: ([Stories]) => <Stories />,
		},
		StoriesAboutUsRoute,
		StoriesGiantBikeSchoolRoute,
		StoriesGiantAdventureRoute,
	],
};

export default routes;
